module.exports = __webpack_public_path__ + "img/menu-rotated.bae85ae2.svg";